import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';

bootstrapApplication(App, appConfig).catch((err) =>
  // Bootstrap failed, so no error handler exists: the console is the only surface (no-console exception).
  // eslint-disable-next-line no-console
  console.error(err),
);
